<template>
    <el-row class="app-container">

        <el-row class="navigation">
            <el-col align="left">
                <el-breadcrumb separator-class="el-icon-arrow-right">
                    <el-breadcrumb-item :to="{ path: '' }">当前位置:</el-breadcrumb-item>
                    <el-breadcrumb-item :to="{ path: '/main/index' }">首页</el-breadcrumb-item>
                    <!--<el-breadcrumb-item :to="{ path: '' }">知识产权综合服务</el-breadcrumb-item>-->
                    <el-breadcrumb-item>政策指南</el-breadcrumb-item>
                </el-breadcrumb>
            </el-col>
        </el-row>
        <el-row style="background-color: #FCFCFC;">
            <div class="search-where">
                <!--类型-->
                <div class="search-item search-select">
                    <div class="search-item-left">
                        类型：
                    </div>
                    <div class="search-item-right">
                        <el-button class="item-right-select" v-for="item in typeOptions" :class="{'font-blue':item.dictValue==queryParams.lawBusType}" @click="handleModeType(item.dictValue)">
                            {{item.dictLabel}}
                        </el-button>
                    </div>
                </div>
                <!--业务类型-->
                <div class="search-item search-select">
                    <div class="search-item-left">
                        业务类型：
                    </div>
                    <div class="search-item-right">
                        <el-button class="item-right-select" v-for="item in bussOptions" :class="{'font-blue':item.dictValue==queryParams.lawRource}" @click="handleBussType(item.dictValue)">
                            {{item.dictName}}
                        </el-button>
                    </div>
                </div>
                <!--区域-->
               <!-- <div class="search-item search-select">
                    <div class="search-item-left">
                        区域：
                    </div>
                    <div class="search-item-right">
                        &lt;!&ndash;<el-button class="item-right-select" :class="{'font-blue':'all'==queryParams.areaCode}" @click="handleModeType('all')">不限</el-button>&ndash;&gt;
                        <el-button class="item-right-select" v-for="item in areaOptions" :class="{'font-blue':item.dictValue==queryParams.lawArea}" @click="handleArea(item.dictValue)">
                            {{item.dictLabel}}
                        </el-button>
                    </div>
                </div>-->
                <!--发布日期-实施日期 -->
               <!-- <el-row style="margin-bottom: 20px;">
                    <el-col :span="12" style="display: flex;">
                        <div class="search-item-left">
                            发布日期：
                        </div>
                        <div class="search-item-right">
                            <el-date-picker
                                    v-model="fbDateRange"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                    </el-col>
                    <el-col :span="12" style="display: flex;">
                        <div class="search-item-left">
                            实施日期：
                        </div>
                        <div class="search-item-right">
                            <el-date-picker
                                    v-model="ssDateRange"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期">
                            </el-date-picker>
                        </div>
                    </el-col>
                </el-row>-->
                <!--搜索查询-->
                <el-row>
                    <el-col :span="12">
                        <div class="search-item search-button">
                            <div class="search-item-left">
                                搜索查询：
                            </div>
                            <div class="search-item-right">
                                <el-input placeholder="请输入法律法规政策、办事指南标题" v-model="queryParams.lawName" clearable class="input-with-select" prefix-icon="el-icon-search">
                                </el-input>
                            </div>
                            <div class="search-item-zr">
                                <el-button type="warning" class="button-search" @click="getList">搜索</el-button>
                            </div>
                        </div>
                    </el-col>
                </el-row>
            </div>

            <el-row class="right-box-row" style="min-height: 430px;">
               <!-- <el-row class="search-page">
                    <el-button type="text" class="order-filed" :class="{'order-blue':queryParams.orderBy=='zhpx'}" @click="handleOrder('zhpx')">综合排序</el-button>
                    <el-button type="text" class="order-filed" :class="{'order-blue':queryParams.orderBy=='fbrq'}" @click="handleOrder('fbrq')">
                        发布日期<i class="el-icon-bottom" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='fbrq'"></i>
                        <i class="el-icon-top" v-else></i>
                    </el-button>
                    <el-button type="text" class="order-filed" :class="{'order-blue':queryParams.orderBy=='ssrq'}" @click="handleOrder('ssrq')">
                        实施日期<i class="el-icon-bottom" v-if="queryParams.isAsc=='desc' && queryParams.orderBy=='ssrq'"></i>
                        <i class="el-icon-top" v-else></i>
                    </el-button>
                    <div style="flex:1;height:31px;border-bottom: 1px solid #cccccc;"></div>
                </el-row>-->

                <el-table v-loading="loading" :data="list" tooltip-effect="light" :header-cell-style="{background:'#f5f5f5f5',color:'#606266'}">
                    <el-table-column label="标题" align="center" header-align="center" :show-overflow-tooltip="true" prop="lawName">
                        <template slot-scope="scope">
                           <div align="left"> <span style="cursor: pointer;color: #1e6abc" @click="openPage(scope.row)">{{ scope.row.lawName }}</span></div>
                        </template>
                    </el-table-column>
                   <!-- <el-table-column label="发布单位" align="center" prop="lawPuborg" width="180"/>-->
                    <el-table-column label="发布日期" align="center" prop="lawPubtime" width="180">
                        <template slot-scope="scope">
                          <span>{{ parseTime(scope.row.lawPubtime, '{y}-{m}-{d}') }}</span>
                        </template>
                    </el-table-column>
                   <!-- <el-table-column label="区域" align="center" prop="lawArea" :width="150">
                        <template slot-scope="scope">
                            {{lawAreasFormat(scope.row.lawArea)}}
                        </template>
                    </el-table-column>
                    <el-table-column label="生效日期" align="center" prop="lawOpfrom" width="180">
                        <template slot-scope="scope">
                            <span>{{ parseTime(scope.row.lawOpfrom, '{y}-{m}-{d}') }}</span>
                        </template>
                    </el-table-column>-->
                </el-table>

                <pagination
				v-show="total>0"
				:total="total"
				:page.sync="queryParams.pageNum"
				:limit.sync="queryParams.pageSize"
				@pagination="getList"
                />
            </el-row>
        </el-row>
    </el-row>
</template>

<script>
    import { listMullevel } from "@/api/law/mullevel/mullevel";
    import {
        lawList,
    } from "@/api/law/jbxx/law";
    export default {
        name: "flfgzc",
        data() {
            return {
                typeOptions:[],
                bussOptions:[],
                areaOptions:[],
                fieldOptions:[],
                // 遮罩层
                loading: false,
                // 总条数
                total: 0,
                list:[],
                queryParams:{
                    pageNum:1,
                    pageSize:10,
                    lawName: undefined,
                    lawType: undefined,
                    lawRource: undefined,
                    lawBusType:undefined,
                    lawArea:undefined,
                    fbBeginDate:undefined,
                    fbEndDate:undefined,
                    ssBeginDate:undefined,
                    ssEndDate:undefined,
                    // orderBy:"zhpx",
                    // isAsc:"asc"
                },
                // 日期范围
                fbDateRange: [],
                // 日期范围
                ssDateRange: [],
                lawTypeOptions: [],
                //法律法规业务类型多级联动options
                lawYwlxOptions:[],
            }
        },
        created() {
			this.getDict();
            this.listMulLevel();
			// this.getlocalStorage();
            this.getList();
            /*
			setTimeout(function() {
				this.clearlocalStorage();
			}, 5000);
			*/
        },
        methods: {
            lawAreasFormat(value) {
                return this.selectDictLabel(this.areaOptions, value);
            },
            listMulLevel(){
                const queryParams={dictType:'law_ywlx'};
                listMullevel(queryParams).then(response => {
                    this.lawYwlxOptions=this.handleDictTree(response.data);
                    this.lawTypeOptions=response.data;
                    for (let bussOption of response.data){
                        if (bussOption.precid != 1){
                            this.bussOptions.push(bussOption)
                        }
                    }
					console.log("listMullevel this.bussOptions",this.bussOptions)
                });
            },
			getDict(){
				this.getDicts("yw_flfg_lx").then(response => {
				  this.typeOptions = response.data;
				});
				// this.getDicts("yw_flfg_ywlx").then(response => {
				//   this.bussOptions = response.data;
				// });
				this.getDicts("yw_flfg_qy").then(response => {
				  this.areaOptions = response.data;
				});
			},
            /*
			getlocalStorage(){
				const en = JSON.parse(localStorage.getItem('IndexSearchContent'));
				if (en != undefined && en != "") {
					this.queryParams.title = en;
				}
				const type1 = JSON.parse(localStorage.getItem('flfg_bussType'));
				if (type1 != undefined && type1 != "") {
					this.queryParams.bussType = type1;
				}
				const type2 = JSON.parse(localStorage.getItem('flfg_modeType'));
				if (type2 != undefined && type2 != "") {
					this.queryParams.modeType = type2;
				}
			},
            */
            toPage(url){
                this.$router.push({
                    path: url,
                });
                this.$store.commit('SET_MAININDEX', url);
            },
            refresh(){
                this.getList();
                // this.getSdList();
                // this.getWhList();
            },
            handleModeType(code){
				this.queryParams.pageNum = 1,
				this.queryParams.pageSize = 10,
                this.queryParams.lawBusType = code;
                this.getList();
            },
            handleBussType(code){
				console.log("code",code);
				this.queryParams.pageNum = 1,
				this.queryParams.pageSize = 10,
                this.queryParams.lawRource = code;
                this.getList();
            },
            handleArea(code){
				this.queryParams.pageNum = 1,
				this.queryParams.pageSize = 10,
                this.queryParams.lawArea = code;
                this.getList();
            },
            getList() {
				console.log("this.queryParams",this.queryParams);
                this.loading = true;
                lawList(this.queryParams).then(response => {
					console.log("lawList  response",response);
                    this.list = response.rows;
                    this.total = response.total;
                    this.loading = false;
                });
            },
            /*
            getSdList() {
                this.loading = true;
                let that = this;
                if (null != this.fbDateRange && '' != this.fbDateRange) {
                    this.queryParams.fbBeginDate = this.fbDateRange[0];
                    this.queryParams.fbEndDate = this.fbDateRange[1];
                }
                if(this.queryParams.modeType!='bszn'){
                    if (null != this.ssDateRange && '' != this.ssDateRange) {
                        this.queryParams.ssBeginDate = this.ssDateRange[0];
                        this.queryParams.ssEndDate = this.ssDateRange[1];
                    }
                }else{
                    this.ssDateRange=[];
                    this.queryParams.ssBeginDate = undefined;
                    this.queryParams.ssEndDate = undefined;
                }
                setTimeout(function () {
                    that.loading = false;
                    if (that.queryParams.pageNum == 1) {
                        that.list = [
                            {recid:'1',title: '山东省特种设备安全条例',area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'2',title: '检验检测机构监督管理办法', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'3',title: '山东省市场监督管理局关于印发山东省市场监管系统企业信用风险分类管理办法（试行）的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'4',title: '山东省市场监督管理局关于印发《山东省市场监督管理行政处罚裁量基准（试行）》的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'5',title: '山东省市场监督管理局 山东省财政厅 关于印发《关于促进专利技术转移转化助力中小企业创新发展工作实施方案》的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'6',title: '关于印发《威海市知识产权质押融资风险补偿实施办法》的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'7',title: '山东省开展深化企业简易注销改革试点工作实施方案', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                        ];
                    } else {
                        that.list = [
                            {recid:'1',title: '山东省特种设备安全条例',area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'2',title: '检验检测机构监督管理办法', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'3',title: '山东省市场监督管理局关于印发山东省市场监管系统企业信用风险分类管理办法（试行）的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'4',title: '山东省市场监督管理局关于印发《山东省市场监督管理行政处罚裁量基准（试行）》的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'5',title: '山东省市场监督管理局 山东省财政厅 关于印发《关于促进专利技术转移转化助力中小企业创新发展工作实施方案》的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'6',title: '关于印发《威海市知识产权质押融资风险补偿实施办法》的通知', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'7',title: '山东省开展深化企业简易注销改革试点工作实施方案', area:'山东省',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                        ];
                    }
                    that.total = 19;
                }, 500);
            },
            getWhList() {
                this.loading = true;
                let that = this;
                if (null != this.fbDateRange && '' != this.fbDateRange) {
                    this.queryParams.fbBeginDate = this.fbDateRange[0];
                    this.queryParams.fbEndDate = this.fbDateRange[1];
                }
                if(this.queryParams.modeType!='bszn'){
                    if (null != this.ssDateRange && '' != this.ssDateRange) {
                        this.queryParams.ssBeginDate = this.ssDateRange[0];
                        this.queryParams.ssEndDate = this.ssDateRange[1];
                    }
                }else{
                    this.ssDateRange=[];
                    this.queryParams.ssBeginDate = undefined;
                    this.queryParams.ssEndDate = undefined;
                }
                setTimeout(function () {
                    that.loading = false;
                    if (that.queryParams.pageNum == 1) {
                        that.list = [
                            {recid:'1',title: '关于印发《威海市知识产权质押融资风险补偿实施办法》的通知',area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'2',title: '威海市财政局关于印发《威海市市级专利专项资金管理实施细则》的通知（已废止）', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'3',title: '威海市人民政府办公室关于印发威海市标准化资助资金管理办法的通知', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'4',title: '《威海市市级专利专项资金使用管理实施细则》政策解读', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'5',title: '威海市知识产权质押融资风险补偿实施办法》解读', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'6',title: '严格监管 严厉处罚——建立权威性和可操作性并重的法律责任制度', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'7',title: '威海市人民政府关于新冠肺炎疫情防控期间进口冷冻冷藏食品报备有关问题的通告', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                        ];

                    } else {
                        that.list = [
                            {recid:'1',title: '中国质量奖管理办法',area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'2',title: '中华人民共和国行政许可法', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'3',title: '最高人民法院关于审理食品药品纠纷案件适用法律若干问题的规定', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'4',title: '医疗器械监督管理条例', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'5',title: '中华人民共和国专利法', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'6',title: '中华人民共和国药品管理法', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'7',title: '中华人民共和国商标法', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                            {recid:'8',title: '中华人民共和国食品安全法实施条例', area:'威海市',ssdate:'2021-10-21', fbdate: '2021-10-19'},
                        ];

                    }
                    that.total = 19;
                }, 500);
            },
            */
            handleOrder(code){
                if(this.queryParams.orderBy==code){
                   // console.log(this.queryParams.isAsc);
                    if(this.queryParams.isAsc=="asc"){
                        this.queryParams.isAsc="desc";
                    }else{
                        this.queryParams.isAsc="asc";
                    }
                }
                if(code=="zhpx"){
                    this.queryParams.isAsc="asc";
                }
                this.queryParams.orderBy=code;
                this.getList();
            },
            openDetail(item){
                this.$router.push({
                    path: '/main/zscqzhfw/flfgzc/detail/'+item.recid
                })
                this.$store.commit('SET_MAININDEX', '/main/zscqzhfw/flfgzc');
            },
            openPage(item){
                this.utils.windowOpen('/main/zscqzhfw/flfgzc/detail/'+item.recid);
            },
			clearlocalStorage(){
                localStorage.removeItem("IndexSearchContent");
                localStorage.removeItem("IndexZscqType1");
                localStorage.removeItem("IndexZscqType2");
			}
        }
    }
</script>

<style scoped>
    .app-container{
        padding:10px;
		width: 1300px !important;
		margin:0 auto;
        background-color: #ffffff;
    }
    .navigation{
        padding:20px 15px;
        line-height: 20px;
        height: 60px;
        background-color: #F5F5F5;
        margin-bottom: 15px;
    }
    .search-select .el-button{
        background-color: #fcfcfc;
    }
    .search-where{
        margin: 10px 0px;
        padding: 15px;
    }
    .el-divider--horizontal{
        margin: 12px 0px;
    }
    .search-item{
        display: flex;
        margin-bottom: 10px;
    }
    .search-item-left{
        width: 80px;
        line-height: 40px;
        font-weight: bold;
        text-align: right;
    }
    .search-item-right{
        flex: 1;
        padding: 0px 10px;
        text-align: left;
    }
    .item-right-select{
        float: left;
        padding: 5px 10px;
        line-height: 30px;
    }
    .font-blue{
        color: #409eff;
    }
    .el-button{
        border: 0px;
    }
    .el-range-editor.el-input__inner{
        padding: 5px 10px;
    }
    .el-range-editor--medium.el-input__inner{
        height: 40px;
    }

    .right-box-row{
        border: 1px solid #cccccc;
        padding: 10px 15px 0;
    }
    .search-page{
        padding: 20px 0px;
        background-color: #ffffff;
        display: flex;
    }
    .order-filed{
        padding: 0px 30px;
        color:#000000;
        border-bottom: 1px solid #cccccc;
    }
    .font-warning{
        color: #e6a23c;
    }
    .font-blue{
        color: #409eff;
    }
    .search-page .el-button+.el-button{
        margin-left: 0;
    }
    .search-page .el-button--medium{
        border-radius: 0;
    }
    .button-search{
        color: #ffffff;
        background-color: #409eff;
    }
    .order-blue{
        color: #409eff;
        border-bottom: 2px solid #409eff;
    }

    /deep/.el-table__body-wrapper .title:hover{
        color: #1482f0;
        cursor: pointer;
    }

</style>